// mainRouting.js
import { BrowserRouter } from "react-router-dom";
import LazyLoad from "../components/lazy_load/lazy_load";
import { lazy } from "react";
const Routing = lazy(()=>import("./routing"))
function MainRouting(props) {
    return (
        <BrowserRouter>
        <LazyLoad><Routing /></LazyLoad> 
        </BrowserRouter>
    );
}
export default MainRouting;
